<script lang="ts" module>
  import TeoBallLoading from '@/ui/elements/teo-ball/TeoBallLoading.svelte';
  import { useCoreStore } from '@/ui/state/use-core-state.svelte';

  const MESSAGES_LOADING = ['Konfiguration wird geladen.'];
  const MESSAGES_DEFAULT = ['TEO wird gestartet.'];
</script>

<script lang="ts">
  let CS = useCoreStore();
  let messages = $derived($CS.bootPhase === 'loading' ? MESSAGES_LOADING : MESSAGES_DEFAULT);
</script>

<div class="flex w-[320px] flex-1 flex-col justify-center">
  <TeoBallLoading class="h-[130px] w-full" {messages} />
</div>
